import {createSlice} from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL

export const dashboardSlice = createSlice({
    name: 'dashboardData',
    initialState: {
    },
    reducers: {
    }
})

export const {  } = dashboardSlice.actions

export const fetchTotalOrdersCount = async () => {
    try {
        const response = await axios.get(`${BASE_URL}dashboard`);
        return response.data
    } catch (err) {
        throw new Error(err);
    }
};

export const fetchPaymentBreakdown = async (data) => {
    try {
        const response = await axios.get(`${BASE_URL}dashboard/paymentStatusBreakdown`, {params: data});
        return response.data
    } catch (err) {
        throw new Error(err);
    }
};

export default dashboardSlice.reducer